import moment from 'moment';

export default (rule, date) => (date ? moment(date, 'DD/MM/YYYY', true).isValid() : true);
